import { TailorVideoContent, VideoTitle } from "../../../../Constants/Constants";
import { VideoData } from "../../../../Data/Messenger/Messenger";
import CommonHeading from "../Common/CommonHeading";

const Video = () => {
  return (
    <div className="reminder-main">
      <CommonHeading title={VideoTitle} sunTitle={TailorVideoContent} />
      {VideoData.map((item, index) => (
        <div className="video-box" key={index}>
          <div className="info-block">
            <iframe className="giphy-embed mb-2" width={245} height={150} src={item} allowFullScreen title="Video Title" />
            <h6 className="mb-2">Morbi eget quam et purus commodo dapibus.</h6>
            <div className="star-ratings">
              <ul className="search-info d-flex align-items-center gap-2">
                <li>3 stars</li>
                <li>590 votes</li>
                <li>Template</li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Video;
